export default __webpack_public_path__ + "media/zurb/img/ecommerce/shopping_flow5-234eff3c370933a684d38a3de44416fb.png";